import { StrictMode, Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import './styles/global.css'
import { I18nProvider } from '@/contexts/I18nContext'
import { useI18n } from '@/contexts/useI18n'

const App = lazy(async () => {
  try {
    return await import('./App.tsx')
  } catch (error) {
    console.error('App chunk failed to load', error)
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations()
        await Promise.all(registrations.map((registration) => registration.unregister().catch(() => undefined)))
      } catch (swError) {
        console.warn('Service worker cleanup failed', swError)
      }
    }
    if (typeof window !== 'undefined') {
      window.location.reload()
    }
    throw error
  }
})

const GlobalFallback = () => {
  const { t } = useI18n()
  return (
    <div className="app-loading-overlay" role="status" aria-live="polite">
      <div className="app-loading-card">
        <Loader2 className="spin" size={40} />
        <span>{t('app.loadingApp', 'Uygulama yükleniyor…')}</span>
      </div>
    </div>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <BrowserRouter>
        <Suspense
          fallback={<GlobalFallback />}
        >
          <App />
        </Suspense>
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>,
)
